import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';

const StandardInput = ({
  name,
  type,
  label,
  size,
  adornment,
  helperText,
  onChange,
  combo: {
    errors,
    classes,
    touched,
    handleBlur,
    initialValues,
  },
  isLoading,
  multiline,
  ...props
}) => {
  let id = '';
  if (!name) {
    id = label.toLowerCase();
  } else {
    id = name;
  }

  return (
    <Grid item className={classes.gridItem} sm={size} xs={12}>
      {isLoading ? (
        <Skeleton height={multiline ? '5rem' : '3.5rem'} />
      ) : (
        <TextField
          type={type}
          name={id}
          fullWidth
          label={label}
          variant="outlined"
          onBlur={handleBlur}
          onChange={onChange}
          defaultValue={initialValues[id]}
          className={classes.textfield}
          InputProps={adornment ? ({
            startAdornment: <InputAdornment position="start">{adornment}</InputAdornment>,
          }) : null}
          error={!!errors[id] && touched[id]}
          helperText={(errors[id] && touched[id]) ? errors[id] : helperText}
          multiline={multiline}
          {...props}
        />
      )}
    </Grid>
  );
};
StandardInput.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  adornment: PropTypes.string,
  helperText: PropTypes.string,
  combo: PropTypes.object.isRequired,
  props: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  multiline: PropTypes.bool,
};

StandardInput.defaultProps = {
  name: '',
  type: 'text',
  adornment: '',
  helperText: '',
  props: {},
  isLoading: false,
  multiline: false,
};

export default StandardInput;
